import { Empty, Table } from "antd";
import React, { useState, useEffect } from "react";
import { getRequest } from "../../../http/axiosConfig/config";
import urls from "../../../http/endpoints/urls";
import ListLoader from "../../re-usables/loaders/ListLoader";
import { DownloadOutlined } from "@ant-design/icons";
import { generateRateChartPDF } from "./RateChartReport";

export default function RateChart() {
  let customerId = localStorage.getItem("userId");
  const [rateChartData, setRateChartData] = useState();
  const [loading, setLoading] = useState(true);
  const appFlavour = process.env.REACT_APP_FLAVOUR;

  const getChartData = async () => {
    try {
      setLoading(true);
      const res = await getRequest(urls.rateChartData(customerId));
      setRateChartData(res);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  let rateChartColumns = [
    {
      title: "Sl. No",
      dataIndex: "sl_no",
      width: 50,
      align: "center",
      render: (text, record, index) => index + 1,
    },
    { title: "Product", dataIndex: "PACKET_NAME", width: 130, align: "left" },
    {
      title: "Basic Rate",
      dataIndex: "BASIC_RATE",
      width: 60,
      align: "center",
    },
    {
      title: "GST Amt",
      dataIndex: "GST",
      width: 65,
      align: "center",
    },
    {
      title: "Rate",

      dataIndex: "RATE",
      width: 60,
      align: "center",
    },
  ];

  if (appFlavour === "CHAMUL")
    rateChartColumns.push({
      title: "MRP",

      dataIndex: "MRP",
      width: 60,
      align: "center",
    });

  useEffect(() => {
    getChartData();
  }, []);

  return (
    <div>
      <div className="page-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span>Rate Chart</span>
        {rateChartData && rateChartData.length > 0 && !loading && (
          <DownloadOutlined
            style={{ fontSize: 32, cursor: "pointer", color: "#1890ff", marginRight: 10 }}
            onClick={() => generateRateChartPDF(rateChartData, rateChartColumns)}
            title="Download Rate Chart PDF"
          />
        )}
      </div>

      <Table
        dataSource={loading ? [] : rateChartData}
        locale={{
          emptyText: loading ? <ListLoader /> : <Empty />,
        }}
        columns={rateChartColumns}
        bordered
        scroll={{ y: "calc(100vh - 380px)", x: "calc(100vw - 40px" }}
        pagination={false}
        style={{ marginTop: 15 }}
      />
    </div>
  );
}
